function IntensityIcon(): JSX.Element {
  return (
    <div>
      <svg
        width="16"
        height="10"
        viewBox="0 0 20 14"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M1.66602 7.85425H4.68164L6.0306 4.97925L8.05143 12.3334L9.99935 1.66675L11.5931 10.1042L13.3431 5.02612L14.7858 7.85425H18.3327"
          stroke="#949494"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </div>
  );
}

export default IntensityIcon;
